module.exports = __webpack_public_path__ + "img/android.bf4518f3.svg";